/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var BERTypeEnum;

(function (BERTypeEnum) {
  BERTypeEnum["DOMESTIC_BER"] = "domestic_ber";
  BERTypeEnum["NON_DOMESTIC_BER"] = "non_domestic_ber";
  BERTypeEnum["DISPLAY_ENERGY_CERTIFICATE"] = "display_energy_certificate";
})(BERTypeEnum || (BERTypeEnum = {}));